// extracted by mini-css-extract-plugin
export default {"Directions":"Directions_Directions__lv5+g","DirectionsBody":"Directions_DirectionsBody__BMZMI","leftPart":"Directions_leftPart__lxDS+"};